import { v4 as uuidv4 } from 'uuid';

import { FlushAction, QueueAction } from '../actions/analytics.action';
import { analyticsConstants } from '../constants';
import { Analytics } from '../shared/types';

export interface AnalyticsState {
  actions: readonly Analytics.IdentifiableAction[];
}

export default function reducer(
  state: AnalyticsState = { actions: [] },
  action: FlushAction | QueueAction
): AnalyticsState {
  switch (action.type) {
    case analyticsConstants.QUEUE: {
      return {
        actions: [
          ...state.actions,
          {
            ...(action as QueueAction).action,
            id: uuidv4(),
          },
        ],
      };
    }
    case analyticsConstants.FLUSH: {
      return {
        actions: state.actions.filter(
          ({ id }) =>
            !(action as FlushAction).actions.map(({ id }) => id).includes(id)
        ),
      };
    }
    default: {
      return state;
    }
  }
}
